import { Component, Input } from '@angular/core'
import { CommonModule } from '@angular/common'
import { Gallery } from '../../interfaces/api/Gallery'
import { getStatusColor } from '../../interfaces/api/GalleryStatus'
import { TranslateModule, TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'app-gallery-item',
  standalone: true,
    imports: [CommonModule, TranslateModule],
  templateUrl: './gallery-item.component.html',
  styleUrls: ['./gallery-item.component.scss']
})
export class GalleryItemComponent {
  @Input() gallery: Gallery;
  @Input() gtmLabel?: string;

  constructor(private translateService: TranslateService) {

  }

  get photoLabel(): string {
    const count = this.gallery.images.length;
    return `${count} ${count === 1 ? this.translateService.instant('my-galleries.photo') : this.translateService.instant('my-galleries.photos')}`;
  }

  getMainImageUrl(): string {
    return this.gallery.images[0].url || 'assets/images/processing-image.png';
  }

  getColorByStatus(): string {
    return getStatusColor(this.gallery.status);
  }
}
